"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.DevicePixelRatio = Math.min(Math.max(1.5, utils_1.runInServer() ? 1 : window.devicePixelRatio), 2);
